import React from 'react';
import {Checkbox, CheckboxGroup, Tooltip} from 'rctui';

import I18n from '../I18n';
import DatePicker from '../DatePicker';
import DateTimePicker from '../DateTimePicker';
import DateTimeRangePicker from '../DateTimeRangePicker';
import ColorPicker from '../ColorPicker';
import Tags from '../Tags';
import SymbolSessions from '../Sessions/Main';
import FormMask from './Mask';
import Table from '../Table/Table';
import KeyValue from './KeyValue/Main';
import FeedSymbol from './FeedSymbol';
import HistorySymbol from './HistorySymbol';
import ComboBox from './ComboBox';
import Collapse, {Panel} from 'rc-collapse';
import Autocomplete from 'react-autocomplete';

const FormRow = React.createClass({
  getDefaultProps: function () {
    return {
      disabled: false,
      type: 'text',
      value: ''
    };
  },
  // getInitialState: function () {
  //   return {
  //     showPassword: false,
  //   };
  // },

  propTypes: {
    disabled: React.PropTypes.bool,
    autoFocus: React.PropTypes.bool,
    label: React.PropTypes.string,
    name: React.PropTypes.string.isRequired,
    type: React.PropTypes.oneOf(['numeric', 'int', 'email', 'string', 'text', 'longtext', 'password',
      'hidden', 'select', 'Date', 'Tags', 'DateTime', 'DateTimeRange', 'Color', 'autocomplete',
      'SymbolSessions', 'float', 'boolean', 'mask', 'KeyValue', 'Table', 'FeedSymbol', 'HistorySymbol', 'multiselect'])
  },

  handleChange: function () {
    let name, value;

    if (arguments.length === 1) {
      let target = arguments[0].target;
      name = target.name;
      value = target.value;
    } else if (arguments.length === 2) {
      name = arguments[0];
      value = arguments[1];
    } else {
      throw Error('FormRow.handleChange: Wrong arguments');
    }

    this.props.onChange && this.props.onChange(name, value);
  },
  // handleToggle: function () {
  //   this.setState((prevState) => ({
  //     showPassword: !prevState.showPassword,
  //   }));
  // },


  checkBoxChange: function (name, value, checked) {
    this.props.onChange && this.props.onChange(name, checked);
  },

  onChoiceTableRow: function (id, checked) {
    let value = this.props.value,
      primaryKey = this.props.data.primaryKey;

    this.props.data.labels.forEach(function (label) {
      if (label.type === 'CheckBox') {
        for (let i = 0; i < value.length; i++) {
          if (value[i][primaryKey] == id) {
            value[i][label.name] = checked
          }
        }
      }
    });

    this.props.onChange && this.props.onChange(this.props.name, value);
  },

  render: function () {
    let input;

    let styles = {
      item: {
        padding: '2px 6px',
        cursor: 'default'
      },

      highlightedItem: {
        color: 'white',
        background: 'hsl(200, 50%, 50%)',
        padding: '2px 6px',
        cursor: 'default'
      },

      menu: {
        borderRadius: '3px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        background: 'rgba(255, 255, 255, 0.9)',
        padding: '2px 0',
        fontSize: '80%',
        position: 'fixed',
        overflow: 'auto',
        maxHeight: '50%',
        zIndex: 1
      }
    };

    switch (this.props.type) {
      // case 'autocomplete':
      //   input = <Autocomplete
      //     value={this.props.value}
      //     items={this.props.options}
      //     menuStyle={styles.menu}
      //     getItemValue={(item) => item}
      //     renderItem={(item, isHighlighted) => (
      //       <div style={isHighlighted ? styles.highlightedItem : styles.item}>{item}</div>)}
      //     onChange={(event, value) => this.handleChange(this.props.name, value)}
      //     onSelect={(value, item) => this.handleChange(this.props.name, value)}
      //     shouldItemRender={this.matchStateToTerm}
      //   />;
      case 'autocomplete':
        input = this.props.options ? ( // Check if this.props.options is defined
          <Autocomplete
            value={this.props.value}
            items={this.props.options}
            menuStyle={styles.menu}
            getItemValue={(item) => item}
            renderItem={(item, isHighlighted) => (
              <div style={isHighlighted ? styles.highlightedItem : styles.item}>{item}</div>
            )}
            onChange={(event, value) => this.handleChange(this.props.name, value)}
            onSelect={(value, item) => this.handleChange(this.props.name, value)}
            shouldItemRender={this.matchStateToTerm}
          />
        ) : null; // Render null or handle the case when options are undefined
        break;
      case 'numeric':
      case 'int':
      case 'float':
      case 'email':
      case 'string':
      case 'text':
        input = <input className="form_full_width" name={this.props.name} type="text" autoFocus={this.props.autoFocus}
                       value={this.props.value} onChange={this.handleChange} disabled={this.props.disabled}/>;
        break;
      case 'longtext':
        input = <textarea className="form_full_width" name={this.props.name} value={this.props.value}
                          onChange={this.handleChange} disabled={this.props.disabled}/>;
        break;
      case 'password':
        input =
        <div className='cust-pass'>
          <input className="form_full_width" name={this.props.name} type="password" autoFocus={this.props.autoFocus}
                 value={this.props.value} onChange={this.handleChange} disabled={this.props.disabled}/>
          {/* <a
              href="#"
              // className={"b-icon b-icon_password"}
              // tabIndex="-1"
              onClick={this.handleToggle}
            >
             {this.state.showPassword ? (
          <img
            src="/img/dc/hide.png"
            alt="Hide Password"
            style={{ width: '20px', height: '20px' }}
          />
        ) : (
          <img
            src="/img/dc/show.jpg"
            alt="Show Password"
            style={{ width: '20px', height: '20px' }}
          />
        )}
            </a> */}
                 </div>
        break;
      case 'hidden':
        input = <input name={this.props.name} type="hidden" value={this.props.value} onChange={this.handleChange}
                       disabled={this.props.disabled}/>;
        break;
      case 'select':
        input = <ComboBox name={this.props.name}
                          className="form_full_width"
                          value={this.props.value}
                          sorted={this.props.data.sorted}
                          options={this.props.options}
                          autoFocus={this.props.autoFocus}
                          onChange={this.handleChange}
                          disabled={this.props.disabled}
        />;
        break;
      case 'multiselect':
        input = <CheckboxGroup data={this.props.options} className="MultiSelect" value={this.props.value} sep={null}
                               onChange={this.handleChange.bind(this, this.props.name)}/>;
        break;
      case 'Date':
        input = <DatePicker name={this.props.name} className="DatePicker" value={this.props.value} onChange={this.handleChange}
                            disabled={this.props.disabled}/>;
        break;
      case 'Tags':
        input = <Tags name={this.props.name} className="Tags" context={this.props.context} value={this.props.value}
                      onChange={this.handleChange} disabled={this.props.disabled} latest={this.props.data.latest}/>;
        break;
      case 'DateTime':
        input =
          <DateTimePicker name={this.props.name} showPresets={this.props.data.showPresets} value={this.props.value}
                          onChange={this.handleChange} disabled={this.props.disabled} className="DatePicker" />;
        break;
      case 'DateTimeRange':
        input =
          <DateTimeRangePicker name={this.props.name} className="DateRangePicker" showPresets={this.props.data.showPresets} value={this.props.value}
                               onChange={this.handleChange} disabled={this.props.disabled}/>;
        break;
      case 'Color':
        input = <ColorPicker name={this.props.name} value={this.props.value} onChange={this.handleChange}
                             disabled={this.props.disabled}/>;
        break;
      case 'SymbolSessions':
        input = <SymbolSessions name={this.props.name}
                                value={this.props.value}
                                onChange={this.handleChange}
                                disabled={this.props.disabled}
                                className="SymbolSessions"
        />;
        break;
      case 'mask':
        input = <FormMask name={this.props.name}
                          value={this.props.value}
                          options={this.props.options}
                          available={this.props.data.available}
                          onChange={this.handleChange}
                          disabled={this.props.disabled}
        />;
        break;
      case 'boolean':
        input = <Checkbox checked={this.props.value} value={this.props.value}
                          onChange={this.checkBoxChange.bind(this, this.props.name)} readOnly={this.props.disabled}/>;
        break;
      case 'KeyValue':
        input = <KeyValue name={this.props.name}
                          value={this.props.value}
                          onChange={this.handleChange}
                          disabled={this.props.disabled}
        />;
        break;
      case 'Table':
        input = <Table name={this.props.name}
                       labels={this.props.data.labels}
                       filter={this.props.data.filter}
                       items={this.props.value}
                       primaryKey={this.props.data.primaryKey}
                       onChoiceRow={this.onChoiceTableRow}
        />;
        break;
      case 'FeedSymbol':
        input = <FeedSymbol name={this.props.name}
                            value={this.props.value}
                            onChange={this.handleChange}
                            disabled={this.props.disabled}
        />;
        break;
      case 'HistorySymbol':
        input = <HistorySymbol name={this.props.name}
                               value={this.props.value}
                               onChange={this.handleChange}
                               disabled={this.props.disabled}
        />;
        break;
    }

    if (this.props.data.tooltip) {
      let tooltip = I18n.message(this.props.data.tooltip)
      input = <Tooltip position="right" tip={tooltip}>{input}</Tooltip>
    }

    let divSize = "";

    let items_2x = ['DateTimeRange', 'HistorySymbol', 'FeedSymbol', 'mask', 'Tags']; // 'Tags', 
    let items_4x = ['KeyValue', 'multiselect'];

    if (this.props.data.size !== undefined) {
      divSize = this.props.data.size;
    } else if (items_2x.indexOf(this.props.type) >= 0) {
      divSize = 'form_item_2x';
    } else if (items_4x.indexOf(this.props.type) >= 0) {
      divSize = 'form_item_4x';
    } else {
      divSize = 'form_item_1x';
    }

    let divClass = "form_item ";
    divClass += divSize;

    if (this.props.type === 'SymbolSessions') {
      if (this.props.data.collapse) {
        return <Collapse prefixCls="collapse">
          <Panel style={{border: 0}} key="0" header={I18n.message(this.props.label)}>
            {input}
          </Panel>
        </Collapse>;
      } else {
        divClass = null;
      }
    }

    let style = {};

    if (this.props.data.new_line) {
      style = {display: 'block'};
    }
    let labelValue = this.props.label ? I18n.message(this.props.label) : '';
    // <span className="red" >*</span>
    return (
      <div className={divClass} style={style}>
        <div className="form_item_title">
    {labelValue && (
      <span>
        {labelValue.replace(/\*+$/, '')}
        <i className='start_validate' style={{ color: labelValue.endsWith('*') ? 'red' : 'black', marginLeft:"2px"}}>{labelValue.endsWith('*') && '*'}</i>
      </span>
    )}
          {/* {this.props.labelRequired 
          ? (<span className="red" >*</span>) : ("") }      */}
        </div>        
        {input}
      </div>
    );
  }
});

export default FormRow;



// WEBPACK FOOTER //
// ./src/js/Component/Form/FormRow.jsx